import { Pipe, PipeTransform } from '@angular/core';
import { Session, SessionStatus } from '../models/tracer.model';
import { GetStatusPipe, STATUS, StatusInfo } from './get-status-pipe';

// Session-level status. The truth lives server-side in sessions.status,
// recomputed by services.RecomputeSessionStatus on every trace write
// (migration 65). The four backend buckets map 1:1 to the four colour
// entries this pipe used to derive by walking session.requests.
//
// The previous walk worked on the request-details page (which loads
// Traces) but rendered every row "not_set" on the home-page list (which
// did not). Reading session.status removes that dependency entirely.
//
// Legacy fallback: if status is missing (older API response, or a
// cached page hitting a not-yet-deployed backend), fall back to walking
// requests so the page degrades gracefully instead of showing every
// row as not_set.
@Pipe({
  name: 'getSessionStatus',
})
export class GetSessionStatusPipe implements PipeTransform {
  private readonly reqStatus = new GetStatusPipe();

  transform(session: Session | undefined | null): StatusInfo {
    if (!session) {
      return STATUS.not_set;
    }

    switch (session.status as SessionStatus | undefined) {
      case 'with_errors':
        return STATUS.error;
      case 'with_warnings':
        return STATUS.warning;
      case 'clean':
        return STATUS.ok;
      case 'pending':
        return STATUS.not_set;
    }

    if (!session.requests?.length) {
      return STATUS.not_set;
    }

    let worst: 'ok' | 'warning' | 'error' | 'not_set' = 'not_set';
    for (const req of session.requests) {
      const label = this.reqStatus.transform(req).label;
      if (label === 'error') {
        return STATUS.error;
      }
      if (label === 'warning') {
        worst = 'warning';
        continue;
      }
      if (label === 'ok' && worst === 'not_set') {
        worst = 'ok';
      }
    }
    return STATUS[worst];
  }
}
